import React from 'react';
import Skeleton from '../common/skeleton';

function EamilRecoverySkeleton() {
  return (
    <div className="mb-5 form-group">
      <Skeleton
        count={1}
        height={10}
        width={95}
        containerClassName={'mb-0 form-label'}
      />
      <Skeleton
        count={1}
        height={38}
        width={553}
        containerClassName={'form-control p-0'}
      />
    </div>
  );
}

export default EamilRecoverySkeleton;
